<template>
  <div class="interpretation-chart">
    <HeadedContainer padded>
      <template v-slot:header>
        {{ $ml.get(`INTERPRETATION CHART`) }}
      </template>
      <BarChart class="bar-chart" :chart-data="chartData" :options="options"/>
    </HeadedContainer>
  </div>
</template>

<script>
import HeadedContainer from '@/components/common/HeadedContainer'
import BarChart from '@/components/common/charts/BarChart'
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      options: {
        legend: {
          display: false
        },
        label: 'INTERPRETATION',
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              callback: (value, index, values) => {
                return this.$ml.get(this.$store.getters['tests/media/renderWarningLevel'](value));
              },
              ticks: {
                autoSkip: false
              }
            }
          }]
        }
      }
    }
  },
  methods: {

    getColor(item) {
      // #EC5A60 - Excessive
      // #F2B14E - High
      // #A7B975 - Adequate
      // #5EC19B - Low

      const lvl = this.$store.getters['tests/media/getWarningLevel'](item.value, item.ext);

      if(lvl === 4) {
        return '#EC5A60';
      }
      else if(lvl === 3) {
        return '#F2B14E';
      }
      else if(lvl === 2) {
        return '#A7B975';
      }
      else if(lvl === 1) {
        return '#5EC19B';
      }
    },
  },
  components: {
    HeadedContainer,
    BarChart,
  },
  computed: {
    ...mapGetters({
      data: 'tests/media/data',
    }),
    labels() {
      let result = []
      this.data
        .filter(n => n.value > 0)
        .map(n => {
          if(n.value > 0)
              result.push(n.type)
          });
        return result
    },
    chartData() {
      let backgroundColors = []
      let values = []
      this.data
        .filter(n => n.value > 0)
        .map(n => {
          backgroundColors.push(this.getColor(n))
          values.push(this.$store.getters['tests/media/getWarningLevel'](n.value, n.ext))
        })
      return {
        labels: this.labels,
        datasets: [{
          label: 'Nutrient',
          backgroundColor: backgroundColors,
          data: values
        }],
      }
    }
  },
}
</script>

<style lang="scss" scoped>

::v-deep {
  .bar-chart {
    width: 100%;
    max-width: 500px;
  }
}

.interpretation-chart {
  margin-top: 8px;
  overflow: hidden;
  .form {
    width: 100%;
    padding: 30px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
  }
}

</style>
